module.exports = __webpack_public_path__ + "img/2025-06-11a_2.a40608a1.jpg";